export default {
  product: {
    name: 'Acquista gift card',
  },
  description: {
    items: {
      delivery: 'Inviata immediatamente via email in formato PDF',
      usage: {
        online: 'Riscattabile solo online',
        online_and_store: 'Riscattabile online e al ristorante',
      },
      value: 'Importi flessibili da {{from}} a {{to}}',
    },
  },
};
